import { render, staticRenderFns } from "./MediaTreeFolderContents.vue?vue&type=template&id=674c1785&scoped=true"
import script from "./MediaTreeFolderContents.vue?vue&type=script&lang=js"
export * from "./MediaTreeFolderContents.vue?vue&type=script&lang=js"
import style0 from "./MediaTreeFolderContents.vue?vue&type=style&index=0&id=674c1785&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674c1785",
  null
  
)

export default component.exports